import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { BodyText, Col, HeadingText, Row } from '@paypalcorp/pp-react';
import {
  getCurrencyParts,
  getCurrencyPartByType,
  formatAmountToOnlyNumbers,
  MIN_INPUT_WIDTH,
  DEFAULT_INPUT_FONTSIZE,
  getInputWidth,
  getFontSize,
} from '../../../../utils/amountUtils';

const CURRENCY_PARTS_TYPE_VALUE = 'value';
const CURRENCY_PARTS_TYPE_SYMBOL = 'symbol';

const SingleAmount = ({ amount, currencyCode, isMobile }) => {
  const [inputFontSize, setInputFontSize] = useState(DEFAULT_INPUT_FONTSIZE);
  const [amountWidth, setAmountWidth] = useState(0);

  const currencyParts = getCurrencyParts(
      formatAmountToOnlyNumbers(amount),
      currencyCode
    ),
    [firstParts = {}] = currencyParts,
    isSymbolDisplayedRightSide = firstParts.type !== CURRENCY_PARTS_TYPE_SYMBOL,
    currencyAmount = getCurrencyPartByType(
      currencyParts,
      CURRENCY_PARTS_TYPE_VALUE
    ),
    currencySymbol = getCurrencyPartByType(
      currencyParts,
      CURRENCY_PARTS_TYPE_SYMBOL
    ),
    amountClassLabel = isSymbolDisplayedRightSide
      ? 'left-align'
      : 'right-align';

  const measuredRef = useCallback(
    (node) => {
      if (node !== null) {
        let inputWidth;

        try {
          inputWidth = getInputWidth(node, amount);
        } catch (e) {
          inputWidth = MIN_INPUT_WIDTH;
        }

        setAmountWidth(inputWidth);
        setInputFontSize(getFontSize(amount, isMobile));
      }
    },
    [amount]
  );

  return (
    <Col className="amount-holder">
      <Row>
        <div className="amount-wrapper">
          {currencySymbol && !isSymbolDisplayedRightSide && (
            <HeadingText
              className="left-align amount-currency-symbol"
              size="sm"
            >
              {currencySymbol}
            </HeadingText>
          )}
          <span
            className={`currrency-amount ${
              currencySymbol ? amountClassLabel : ''
            }`}
            id="currency-amount"
            style={{
              width: amountWidth,
              fontSize: inputFontSize,
            }}
            ref={measuredRef}
          >
            {currencyAmount}
          </span>

          {currencySymbol && isSymbolDisplayedRightSide && (
            <HeadingText
              className="right-align amount-currency-symbol"
              size="sm"
            >
              {currencySymbol}
            </HeadingText>
          )}
        </div>
      </Row>
      <BodyText strong id="currency-code">
        {currencyCode}
      </BodyText>
    </Col>
  );
};

SingleAmount.propTypes = {
  amount: PropTypes.string,
  currencyCode: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default SingleAmount;
